import React from 'react';
import { Input, Table } from 'antd';
import {
  LeftCenteredContainer,
  PopoverContainer,
  CenteredContainer
} from './styled';

export default function AccordianTable({ thresholds = [] }) {
  const tableColumns = [
    {
      title: <b>Risk Indicator</b>,
      render: ({ name = '' }) => (
        <LeftCenteredContainer>{name}</LeftCenteredContainer>
      )
    },
    {
      title: <b>Threshold</b>,
      render: ({ threshold = {} }) => (
        <CenteredContainer>
          <Input
            className="small"
            disabled
            value={threshold?.value}
            style={{
              fontSize: '12px',
              maxWidth: '100px',
              borderRadius: '5px',
              padding: '3px'
            }}
          />
        </CenteredContainer>
      )
    }
  ];

  const onChangeNumOfRows = (current, pageSize) => {
    console.log(current, pageSize);
  };

  return (
    <PopoverContainer>
      {thresholds?.map(({ id, name, derivedIndicators, total }, i) => (
        <details key={id} open={i ? false : true}>
          <summary
            className="p-2 mt-2"
            style={{ background: '#F7F7F8', borderRadius: '10px' }}>
            <strong>{name}</strong>{' '}
          </summary>

          <div className="mt-2 ml-4" style={{ backgroundColor: '#fff' }}>
            <Table
              dataSource={derivedIndicators}
              columns={tableColumns}
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 5,
                showSizeChanger: true,
                onShowSizeChange: onChangeNumOfRows,
                pageSizeOptions: ['5', '10', '15', '20'],
                showTotal: (total) => <small>{total} Records</small>
              }}
            />
          </div>
        </details>
      ))}
    </PopoverContainer>
  );
}
